import { inject } from '@angular/core';
import { TaApiService } from '@shared/services';
import { PopoverConfig, PopoverHandlerConfig } from '../generic-popover.interfaces';
import { defaultCancelAction, defaultConfirmAction } from './default-actions';
import { taClusterHistoryFormConfig } from '@shared/components/edit-create-form';

export const taClusterHistoryPopoverConfig = (
  onSuccess: () => void,
  onCancel: () => void,
  actionHandlers?: Record<string, (popoverConfig: PopoverHandlerConfig, formValue: any) => void | Promise<any>>
): PopoverConfig => {
  const taApiService = inject(TaApiService);

  return {
    width: '500px',
    title: 'Chuyển cụm trợ giảng',
    dismissable: true,
    styleClass: 'p-fluid',
    formConfig: taClusterHistoryFormConfig(),
    actions: [defaultCancelAction, defaultConfirmAction],
    actionHandlers,
    handlerConfig: {
      service: taApiService,
      method: 'createTaClusterHistory',
      updateMethod: 'updateTaClusterHistory',
      entityLabel: 'lịch sử cụm trợ giảng',
      commonDataTransform: (formValue: any) => ({
        taId: formValue.taId || formValue.id,
        clusterId: formValue.clusterId,
        available: formValue.available || false,
        fromDate: formValue.fromDate,
        note: formValue.note
      }),
      updateDataTransform: (formValue: any) => ({
        id: formValue.id
      }),
      initialDataTransform: (rawData: any) => ({
        id: rawData?.taId || rawData?.id,
        taId: rawData?.taId || rawData?.id,
        fromDate: null
      }),
      onSuccess,
      onCancel
    } as PopoverHandlerConfig
  };
};

